import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EscalationsRoutingModule } from './escalations-routing.module';
import { EscalationsComponent } from './escalations.component';
import { TripsComponent } from './components/trips/trips.component';
import { AgGridModule } from 'ag-grid-angular/src/aggrid.module';
import { FormsModule } from '@angular/forms';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { MyDatePickerModule } from 'mydatepicker';

import { Trip2ThemeModule } from '../../trip2-theme/trip2-theme.module';
import { ReservationService } from '../trip-reservations/reservations.service';
import { CompaniesService } from '../companies/companies.service';
import { DispatchService } from '../dispatch/dispatch.service';
import { MassiveChangeStatusModule } from '../dispatch/components/massive-change-status/massive-change-status.module';
import { EditReservationModule } from '../trip-reservations/edit-reservation/edit-reservation.module';
import { PayorsService } from '../payors/payors.service';
import { BooleanCheckComponent } from '../A2-utils/grid-components/boolean-check/boolean-check.component';
import { GridComponentsModule } from '../A2-utils/grid-components/grid-components.module';
import {ProvidersService} from '../providers/providers.service';
import { GridLayoutMenuModule } from '../../utils/grid-layout-menu/grid-layout-menu.module';
import { DirectivesModule } from '../../directives/directives.module';
import { EscalationService } from '../../services/escalation.service';


@NgModule({
  imports: [
    CommonModule,
    EscalationsRoutingModule,
    Trip2ThemeModule,
    AgGridModule.withComponents([BooleanCheckComponent]),
    GridComponentsModule,
    FormsModule,
    MassiveChangeStatusModule,
    EditReservationModule,
    MyDateRangePickerModule,
    MyDatePickerModule,
    DirectivesModule,
    GridLayoutMenuModule
  ],
  declarations: [EscalationsComponent, TripsComponent],
  providers: [
    ReservationService,
    CompaniesService,
    DispatchService,
    PayorsService,
    ProvidersService,
    EscalationService
  ]
})
export class EscalationsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/escalations/escalations.module.ts